import styles from '../../Summary.module.css';
import { Text } from '../../../../foundations';
import { Accordion } from '../../../accordion';
import { Box } from '../../../box';
import { ReactNode, useState } from 'react';

export type SummaryAccordionProps = {
	textShow: string;
	textHide: string;
	triggerPosition?: 'top' | 'bottom';
	children: ReactNode;
};

const SummaryAccordionHeader = (props: Pick<SummaryAccordionProps, 'textShow' | 'textHide'>) => {
	const [collapsed, setCollapsed] = useState(true);
	const { textHide, textShow } = props;
	return (
		<Accordion.Header
			className={styles.summary_accordion_header}
			onClick={() => {
				setCollapsed((prevState) => !prevState);
			}}
		>
			<Text className={styles.summary_accordion_title} as="span" font="verdana" size="md-regular">
				{collapsed ? textShow : textHide}
			</Text>
		</Accordion.Header>
	);
};
SummaryAccordionHeader.displayName = 'SummaryAccordionHeader';

export const SummaryAccordion = (props: SummaryAccordionProps) => {
	const { triggerPosition = 'bottom', textShow, textHide, children } = props;
	return (
		<Accordion type="single">
			<Accordion.Item value="summary-accordion">
				{triggerPosition === 'top' && <SummaryAccordionHeader textShow={textShow} textHide={textHide} />}
				<Accordion.Content>
					<Box className={styles.summary_item}>{children}</Box>
				</Accordion.Content>
				{triggerPosition === 'bottom' && <SummaryAccordionHeader textShow={textShow} textHide={textHide} />}
			</Accordion.Item>
		</Accordion>
	);
};
SummaryAccordion.displayName = 'SummaryAccordion';
